

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { EsitoConsegnaInfratel } from "src/app/models/dto/esitoConsegnaInfratel.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { ExcelService } from "src/app/services/excelService.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { Timestamp } from 'firebase/firestore'; 
  

@Component({
    selector: "component-modifica-date-accettazione",
    templateUrl: "./dialog-modifica-date-accettazione.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogModificaDateAccettazioneInfratel implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected approvaInvioInfratelForm: FormGroup;
    protected isApprovandoInvioInfratel:boolean = false;
    protected fase:number = 1;
    private dataInvio:Date;
    protected labelData:String = 'ORDINE INFRATEL';
    private dataPecOde:Date;
    private dataRispostaInfratel:Date;
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
      private messageService: MessageService,
    ) {
      this.pratica          = this.config.data.pratica;
      this.fase             = this.config.data.fase;
      if(this.fase==1){
        this.dataInvio            = this.pratica.dataInvioInfratelFase1 ? this.convertFirestoreTimestampToDate(this.pratica.dataInvioInfratelFase1): null;
        this.dataPecOde           = this.pratica.dataPecOde ? this.convertFirestoreTimestampToDate(this.pratica.dataPecOde): null;
        this.dataRispostaInfratel = this.pratica.dataRispostaInfratelFase1 ? this.convertFirestoreTimestampToDate(this.pratica.dataRispostaInfratelFase1): null;
        if(this.pratica.bando==='BANDO 2'){
          this.labelData = 'PEC ODE';
        }
        
      }else if(this.fase==2){
        this.dataInvio       = this.pratica.dataInvioInfratelFase2 ? this.convertFirestoreTimestampToDate(this.pratica.dataInvioInfratelFase2): null;
        
      }else if(this.fase==3){
        this.dataInvio       = this.pratica.dataInvioInfratelFase3 ? this.convertFirestoreTimestampToDate(this.pratica.dataInvioInfratelFase3): null;
      }
      this.logger.info();
      this.approvaInvioInfratelForm = this.formBuilder.group({
        dataRicevimento:  [ this.dataRispostaInfratel, [Validators.required]],
        dataInvio:        [ this.dataInvio, [Validators.required]],
        dataPecODE:       [ this.dataPecOde, [Validators.required]],
      });
      
    }
    ngOnInit() {
    }

    private convertFirestoreTimestampToDate(timestamp: Timestamp): Date {
      return timestamp.toDate();
    }
    onDataRicevimentoSelect(event: any): void {
      console.log('Data selezionata:', event);
      this.approvaInvioInfratelForm.patchValue({
        dataPecODE: event,
      });
    }
  
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isApprovandoInvioInfratel = true;
        let esitoConsegna:EsitoConsegnaInfratel = new EsitoConsegnaInfratel();
        esitoConsegna.esitoPositvo  = true;
        esitoConsegna.dataInvio     = this.approvaInvioInfratelForm.get('dataInvio').value;
        esitoConsegna.dataResponso  = this.approvaInvioInfratelForm.get('dataRicevimento').value;
        esitoConsegna.dataPecOde    = this.approvaInvioInfratelForm.get('dataPecODE').value;
        if(this.fase==1){
          this.praticheService.presidioTIMComunicaEsitoConsegnaFase1(this.pratica.id, esitoConsegna).subscribe( {
            next: (res) => {
              this.isApprovandoInvioInfratel = false;
              this.dialogRef.close({ success: true});
            },  error: (e) => {
              this.isApprovandoInvioInfratel = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di comunicazione dell'esito della consegna della FASE 1 della pratica!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {}
            }
          );
        }else if(this.fase==2){
          this.praticheService.presidioTIMComunicaEsitoConsegnaFase2(this.pratica.id, esitoConsegna).subscribe( {
            next: (res) => {
              this.isApprovandoInvioInfratel = false;
              this.dialogRef.close({ success: true});
            },  error: (e) => {
              this.isApprovandoInvioInfratel = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di comunicazione dell'esito della consegna della FASE 2 della pratica!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {}
            }
          );
        }else if(this.fase==3){
          this.praticheService.presidioTIMComunicaEsitoConsegnaFase3(this.pratica.id, esitoConsegna).subscribe( {
            next: (res) => {
              this.isApprovandoInvioInfratel = false;
              this.dialogRef.close({ success: true});
            },  error: (e) => {
              this.isApprovandoInvioInfratel = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di comunicazione dell'esito della consegna della FASE 3 della pratica!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {}
            }
          );
        }
        
       }
    }
  
  }